'use client'

import type { ClientErrorPageProps } from '@maestro/commerce-blocks/components/client-error-page/client-error-page.types'

import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import ClientErrorLogo from '@maestro/commerce-blocks/components/client-error-page/client-error-logo'
import { useScrollToHeader } from '@maestro/commerce-blocks/hooks/use-scroll-to-header'
import { createLogger } from '@maestro/core/logger'
import { Accordion, AccordionItem } from '@pearlconvert/ui/components/accordion'

import '@maestro/commerce-blocks/components/client-error-page/styles/client-error-page.scss'

const log = createLogger('maestro:commerce-blocks:error-page')

export default function ClientErrorPage(props: ClientErrorPageProps) {
  const { error, showErrorInfo } = props
  useScrollToHeader(true)
  const t = useTranslations('commerce-blocks.client-error')

  useEffect(() => {
    if (error) {
      log.error(`[Error Page] Error Caught. Digest: ${error.digest}\n`, error)
    }
  }, [error])

  return (
    <>
      <div className="client-error" data-testid="client-error-page">
        <div className="client-error__card">
          <div className="client-error__icon">
            <ClientErrorLogo />
          </div>

          <h1 className="client-error__title">{t('title')}</h1>
          <p className="client-error__description">{t('description')}</p>

          <div className="client-error__details-wrapper">
            <Accordion canOpenMultiple>
              <AccordionItem title={t('show-details')} location="Error page">
                <div className="client-error__details-content">
                  {error?.digest && (
                    <>
                      <h3 className="client-error__details-heading">
                        {t('error-digest')}
                      </h3>
                      <pre className="client-error__details-pre client-error__details-pre--digest">
                        {error.digest}
                      </pre>
                    </>
                  )}
                  {showErrorInfo && (
                    <>
                      <h3 className="client-error__details-heading">
                        {t('error-message')}
                      </h3>
                      <pre className="client-error__details-pre">
                        {error?.message}
                      </pre>

                      <h3 className="client-error__details-heading">
                        {t('stack-trace')}
                      </h3>
                      <pre className="client-error__details-pre client-error__details-pre--stack">
                        {error?.stack}
                      </pre>
                    </>
                  )}
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  )
}
